<div class="access-denied-container">
  <div class="access-denied-content">
    <img
      src="./assets/images/illust/il-no-access.svg"
      alt="Blocked Access Illustration"
    />
    <ng-container *ngIf="type === 'invalid'">
      <h1 class="access-denied-title">
        {{ "access_denied.title_invalid" | translate }}
      </h1>
      <p class="access-denied-subtitle">
        {{ "access_denied.subt_invalid" | translate }}
      </p>
    </ng-container>
    <ng-container *ngIf="type === 'expired'">
      <h1 class="access-denied-title">
        {{ "access_denied.title_expired" | translate }}
      </h1>
      <p class="access-denied-subtitle">
        {{ "access_denied.subt_expired" | translate }}
      </p>
    </ng-container>
  </div>
</div>
